package com.jingfangpai.medicalRecord.model

import com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptom
import com.jingfangpai.common.orm.mapping.MedicalRecordSignSymptomCharacteristic
import com.jingfangpai.common.orm.mapping.enums.SignSymptomName
import kotlinx.serialization.Serializable

@Serializable
class MedicalRecordSignSymptomDto : MedicalRecordSignSymptom(){
    var signSymptomName:SignSymptomName? = null
    var signSymptomNameAlias:String?=null
    var characteristics:Array<MedicalRecordSignSymptomCharacteristicDto> = arrayOf()
}